import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React components
import Sidenav from "examples/Sidenav";

// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeDark from "assets/theme-dark";

// Material Dashboard 2 React routes
import getRoutes from "routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

// Images
import brandWhite from "assets/images/TeslaSubseaLogo.png";
import brandDark from "assets/images/logo-ct-dark.png";

// MSAL for login
import { useMsal } from "@azure/msal-react";

export default function App() {
  const [controller] = useMaterialUIController();
  const { layout, sidenavColor, transparentSidenav, whiteSidenav, darkMode } = controller;

  const { pathname } = useLocation();
  const { instance } = useMsal();
  const navigate = useNavigate();

  const account = instance.getActiveAccount();
  const token = account?.idTokenClaims;
  const userRoles = token?.roles || [];

  // Scroll to top on route change
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // Role-based route filtering
  const filteredRoutes = getRoutes().filter((route) => {
    if (!route.allowedRoles) return true;
    return route.allowedRoles.some((r) => userRoles.includes(r));
  });

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <Sidenav
          color={sidenavColor}
          brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
          brandName="Tesla Subsea"
          routes={filteredRoutes}
        />
      )}
      <Routes>
        {filteredRoutes.map((route) => (
          <Route exact path={route.route} element={route.component} key={route.key} />
        ))}
        <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
      </Routes>
    </ThemeProvider>
  );
}
